interface SaveNoticeProps {
  message: string | null;
  error: string | null;
  onDismiss: () => void;
}

export default function SaveNotice({ message, error, onDismiss }: SaveNoticeProps) {
  if (!message && !error) return null;

  const isError = Boolean(error);

  return (
    <div
      className={`flex items-start gap-3 rounded-md border px-4 py-3 mb-6 ${
        isError
          ? 'bg-red-50 border-red-200 text-red-700'
          : 'bg-green-50 border-green-200 text-green-800'
      }`}
      role={isError ? 'alert' : 'status'}
    >
      <span className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
        <i className={isError ? 'ri-error-warning-line text-base' : 'ri-checkbox-circle-line text-base'} />
      </span>
      <p className="text-sm flex-1 min-w-0">{error || message}</p>
      <button
        type="button"
        onClick={onDismiss}
        className="w-6 h-6 flex items-center justify-center rounded text-current/60 hover:bg-black/5 transition-colors cursor-pointer flex-shrink-0"
        aria-label="Dismiss message"
      >
        <span className="w-3.5 h-3.5 flex items-center justify-center">
          <i className="ri-close-line text-sm" />
        </span>
      </button>
    </div>
  );
}